import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { duplicatesRequestLimit } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';

class GetDuplicatesListAPICall extends APICallV4 {
    _method = 'duplicates';
    _type: Method = 'get';
    _retriesCount = 0;
}

export const getDuplicatesListCall = (cursor?: string) =>
    new GetDuplicatesListAPICall().makeRequest({ limit: duplicatesRequestLimit, cursor });
